export const IS_TEST = false;
export const APP_VERSION = "2.5.3";

export const REQUEST_STATUS = {
  ACTIVE: "active",
  UPCOMING: "upcoming",
  EARLIER: "earlier",
  ERASED: "erased",
};
